import React from "react";

export function PageHeader({ title, subtitle, icon: Icon, action }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-7">
      <div className="flex items-start gap-3">
        {Icon && (
          <div className="h-10 w-10 rounded-xl bg-emerald-500/15 border border-emerald-500/20 flex items-center justify-center shrink-0">
            <Icon className="h-5 w-5 text-emerald-400" />
          </div>
        )}
        <div>
          <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-slate-400">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}

export function Panel({ children, className = "", ...rest }) {
  return (
    <div className={`rounded-2xl border border-slate-800 bg-slate-900/60 p-5 sm:p-6 ${className}`} {...rest}>{children}</div>
  );
}

export function EmptyState({ icon: Icon, title, desc, action }) {
  return (
    <div className="text-center py-14 px-6" data-testid="empty-state">
      {Icon && <div className="mx-auto mb-4 h-14 w-14 rounded-2xl bg-slate-800/70 flex items-center justify-center"><Icon className="h-7 w-7 text-slate-500" /></div>}
      <h3 className="font-display font-semibold text-lg">{title}</h3>
      {desc && <p className="mt-1.5 text-sm text-slate-400 max-w-md mx-auto">{desc}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
